// extracted by mini-css-extract-plugin
export var header = "Header-module--header--1Qt4T";
export var shadowed = "Header-module--shadowed--1niVC";